import React from "react";
import { Pie } from "@nivo/pie";
import styles from "./index.module.css";

export const PieChart = () => {
  const data = [
    {
      id: "make",
      value: 469,
      color: "#24AEFC"
    },
    {
      id: "scala",
      value: 107,
      color: "#935ccb"
    },
    {
      id: "php",
      value: 251,
      color: "#ffc246"
    }
  ];

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <Pie
        data={data}
        innerRadius={0.8}
        width={230}
        height={230}
        legends={[]}
        enableRadialLabels={false}
        enableSlicesLabels={false}
        isInteractive={false}
        colors={e => e.color}
      />
      <div className={styles["pie-labels"]}>
        <div className={styles["container"]}>
          <p>0</p>
          <div className={styles["label"]}>
            <span style={{ backgroundColor: "#24AEFC" }}></span>
            <p>Fixo</p>
          </div>
        </div>
        <div className={styles["container"]}>
          <p>0</p>
          <div className={styles["label"]}>
            <span style={{ backgroundColor: "#935CCB" }}></span>
            <p>Variável</p>
          </div>
        </div>
        <div className={styles["container"]}>
          <p>0</p>
          <div className={styles["label"]}>
            <span style={{ backgroundColor: "#FFC246" }}></span>
            <p>Comentários e outros</p>
          </div>
        </div>
      </div>
    </div>
  );
};
